var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import ConfigurationComponent from '../base/ConfigurationComponent';
var ChartCategoryAxisRangeLabels = function (props) {
    return (React.createElement(ConfigurationComponent, __assign({}, props, { _chartKey: "rangeLabels" })));
};
ChartCategoryAxisRangeLabels.defaultProps = {
    visible: true
};
export default ChartCategoryAxisRangeLabels;
//# sourceMappingURL=RangeLabels.js.map